// extracted by mini-css-extract-plugin
export default {"clear":"AboveTheFoldMessage_clear__tEG8q","markdown":"AboveTheFoldMessage_markdown__gl2VX"};